import React, { Fragment } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { isSingleChat } from "../../../../../../Helpers/Chat/ChatHelper";
import {
  ForwardHoc,
  CopyTextHoc,
  MessageInfoHoc,
  ReplyHoc,
  DropDownloadHoc,
  IconReportHoc,
  DeleteMessageHoc,
} from "../../../../../../assets/images";
import { MEDIA_MESSAGE_TYPES } from "../../../../../../Helpers/Constants";
import { useSelector } from "react-redux";

const WatchClickOutside = (props = {}) => {
  const container = React.useRef(null);
  const { onClickOutside , children } = props;

  const handleClick = (event) => {
    const { target } = event;
    if (typeof onClickOutside !== "function") {
      return;
    }
    if (target !== container && !container.current.contains(target)) {
      onClickOutside(event);
    }
  };

  React.useEffect(() => {
    document.body.addEventListener("click", handleClick);
    return(() => {
      document.body.removeEventListener("click", handleClick);
    });
  }, []);

  return <div ref={container}>{children}</div>;
};

const DropDownComponent = (props = {}) => {
  const {
    action,
    msgId,
    recall,
    chatType = "",
    closeDropDown,
    messageInfoOptions = true,
    isSender,
    msgType,
    messageObject = {},
    // favouriteStatus,
  } = props;

  const globalState = useSelector(state => state);
  
  const { featureFlagList: { data: { isDeleteMessageEnabled = false }} = {} } = globalState;


  const issingleChat = isSingleChat(chatType);
  const container = window.document && document.getElementById("message-containner");
  const ClientHeight = container.clientHeight;
  const [dropposition, setDropPosition] = React.useState(false);
  const { msgBody : { media : { caption } = {}} = {}} = messageObject

  React.useLayoutEffect(() => {
    const messagenew = document.getElementById(`${msgId}`);
    const dropDDOwn = document.querySelector(".menu-dropdown");
    if (!messagenew) return;
    if (
      ClientHeight - messagenew.getBoundingClientRect().top - 85 <
      dropDDOwn.getBoundingClientRect().height
    ) {
      setDropPosition(true);
      let updateHeigth = dropDDOwn.getBoundingClientRect().height + 4;
      let heigth = `-${updateHeigth}px`;
      if (dropposition) {
        dropDDOwn.style.top = heigth;
      }
    } else {
      setDropPosition(false);
    }
    dropDDOwn.style.display = "block";
  }, [dropposition]);

  return (
    <OutsideClickHandler
      onOutsideClick={(e) => {
        setTimeout(() => {
          e.preventDefault();
          closeDropDown();
        }, 100);
      }}
    >
      <ul
        style={{ display: "none", padding: recall ? 0 : "" }}
        className={`menu-dropdown open ${dropposition ? "popup-top" : ""}`}
        onClick={(event) => {
          action(event);
          event.stopPropagation();
        }}
      >
        {!recall && (
          <Fragment>
            <li className="reply" title="Reply">
              <i>
                <ReplyHoc viewBox="0 0 14 11"/>
              </i>
              <span>Reply</span>
            </li>
            <li className="forward" title="Forward">
              <i>
                <ForwardHoc  viewBox="0 0 13.569 13.569"/>
              </i>
              <span>Forward</span>
            </li>
            {(caption || msgType === "text") &&
              <li className="Copy" title="Copy">
              <i>
                <CopyTextHoc />
              </i>
              <span>Copy</span>
            </li>
            }

            {/** {favouriteStatus === 0 ? (
              <li className="Starred" title="Starred">
                <i>
                  <StarredHoc />
                </i>
                <span>Star</span>
              </li>
            ) : (
              <li className="Starred" title="UnStarred">
                <i>
                  <UnStarHoc />
                </i>
                <span>Unstar</span>
              </li>
            )} */}
          </Fragment>
        )}

        {isDeleteMessageEnabled && (
          <li className="delete" title="Delete">
            <i>
              <DeleteMessageHoc viewBox="0 0 14 14"/>
            </i>
            <span>Delete</span>
          </li>
        )}
        {!issingleChat && !recall && !isSender && messageInfoOptions && (
          <li className="messageinfo 1" title="MessageInfo">
            <i>
              <MessageInfoHoc viewBox="0 0 14 14"/>
            </i>{" "}
            <span>Message Info</span>
          </li>
        )}
        {MEDIA_MESSAGE_TYPES.includes(msgType) && (
          <li className="Download" title="Download">
            <i>
              <DropDownloadHoc viewBox="0 0 21.87 20.308"/>
            </i>{" "}
            <span>Download</span>
          </li>
        )}
        {isSender && (
          <li className="Report" title="Report">
            <i>
              <IconReportHoc viewBox="0 0 14 14"/>
            </i>
            <span>Report</span>
          </li>
        )}
      </ul>
    </OutsideClickHandler>
  );
};

export default React.memo((props) => {
  const {
    isSender = true,
    chatType = "",
    messageInfoOptions = true,
    recall,
    handleDropDown,
    msgid,
    msgType,
    favouriteStatus,
    messageAction = () => {},
    closeDropDown,
    messageObject,
  } = props;

  return (
    <WatchClickOutside onClickOutside={handleDropDown}>
      <DropDownComponent
        closeDropDown={closeDropDown}
        msgId={msgid}
        recall={recall}
        isSender={isSender}
        chatType={chatType}
        action={messageAction}
        messageInfoOptions={messageInfoOptions}
        msgType={msgType}
        favouriteStatus={favouriteStatus}
        messageObject={messageObject}
      />
    </WatchClickOutside>
  );
});
